// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
import { InitPageClasses } from "./PageRegister";
import { ButtonBadge } from "./Components/ButtonBadge";
import { QRCodeScanner } from "./Components/QRCodeScanner";
require('intro-ts/lib/bandle/style.min.css');
const { IntroTS } = require('intro-ts');
const intro = new IntroTS();
const Genesis = require("./Genesis");

// for details on configuring this project to bundle and minify static web assets.
$(document).ready(function () {
    $("#ulCategory li").on('click', function () {
        $(this).siblings().removeClass('circle-nav');
        $(this).siblings().removeClass('active-nav');
        //$(this).addClass('active')
    })
});

interface CoachMakersData {
    Key: string;
    Value: string;
}

export default class InitPage {
    public static Init() {

        const _iSitePathBase = (window as any)._iSitePathBase;

        let path = window.location.pathname;
        if (_iSitePathBase !== "/") {
            const basePathName = _iSitePathBase.replaceAll("/", "");
            path = path.replace(basePathName + "/", "");
        }
        const paths = path.split('/');

        if (paths.length < 2) return;
        if (paths[1].length === 0) return;

        let pageClass = 'ISiteMobile' + this.Capitalize(paths[1]);

        if (paths.length > 2) {
            pageClass += this.Capitalize(paths[2]) + 'Page';
        }
        else {
            pageClass += 'IndexPage';
        }

        try {
            const pageObject: any = new InitPageClasses[pageClass]();
            pageObject.Init();
            console.log('PageInit run for ' + pageClass);
        }
        catch (e) {
            console.log(e + pageClass + ' not found for page, create and include reference to js and ensure it is called before custom.js');
        }

        this.MinimizeHomeWhenActionButtonsActive();
        this.initilizeinfomenu();

        // Removed.  This should be fixed later with ticket 13512
        //this.checkMobileconfig();

        const badges = new ButtonBadge();
        badges.Init();

        const scanner = new QRCodeScanner();
        scanner.Init();
    }

    public static MinimizeHomeWhenActionButtonsActive() {
        var ab = $('#footer-actions-button-bar');
        if (ab.length) {
            $('#home-nav').css({ top: '20px' });
            $('#home-nav span').hide();
        }
    }

    public static ManagelocalStorage(state: boolean) {
        var coachelement = $('#switchCoachMarks')[0];
        if (coachelement != undefined) {
            const toogle = coachelement as HTMLInputElement;
            toogle.checked = state;
            localStorage.setItem("FirstTimeCoach", String(state));
        }
    }

    public static checkMobileconfig() {
        var localStg = localStorage.getItem('FirstTimeCoach');
        if (localStg == "" || localStg == null) {
            $.ajax({
                url: Genesis.url('Home/UserMobileConfigurations'),
                success: function (data) {
                    if (data == null || data == false) {
                        $.post(Genesis.url('Home/SaveMobileConfigurations'), function (data) {
                            if (data == true) {
                                InitPage.ManagelocalStorage(data);
                                InitPage.LoadCoachMarks();
                            }
                        });
                    }
                    else {
                        InitPage.ManagelocalStorage(false);
                    }
                },
                cache: false
            });
        }
        else {
            this.PopulateCoachMarks();
        }
    }

    public static PopulateCoachMarks() {
        var updatedStg = localStorage.getItem('FirstTimeCoach');
        if (updatedStg == "true") {
            InitPage.ManagelocalStorage(true);
            this.LoadCoachMarks();
        }
    }

    public static initilizeinfomenu() {

        $('#switchCoachMarks').change(function (event) {
            const toogle = $('#switchCoachMarks')[0] as HTMLInputElement;
            if (toogle.checked) {
                InitPage.ManagelocalStorage(true);
                InitPage.LoadCoachMarks();
            }
            else {
                InitPage.ManagelocalStorage(false);
            }
            event.preventDefault();
        });
    }

     public static  LoadCoachMarks() {
        var i = 1;
        const coachar: CoachMakersData[] = [];
        $("[data-coach]").each(function () {
            var coachdata = $(this).data('coach');
            if ($('[data-coach~=' + coachdata + ']').attr('id') == '' || $('[data-coach~=' + coachdata + ']').attr('id') == undefined) {
                $('[data-coach~=' + coachdata + ']').attr('id', "coach" + i++);
            }
            const coachData = {
                Key: coachdata,
                Value: ''
            };
            coachar.push(coachData);
        });


        $.post(Genesis.url('Home/GetCoachResourceData'), { coacharr: coachar }, function (data) {
            var steps = 1;
            $.each(data, function (i, data) {
                var idname = $('[data-coach~=' + data.key + ']').attr('id');
                if (data.value != '' && data.value != undefined && data.value != null) {
                    intro.addStep("#" + idname, data.value, steps++);
                }
            });
            intro.setOptions({
                disableInteraction: true
            }).start();
            $(".introts-tooltipbuttons a").attr("href", "#");
        });
    }

    public static Capitalize(s: string) {
        return s.charAt(0) + s.slice(1)
    }
};